export const ProfilesModel = {
    orgs_names: "",
    panels_names: "",
    organizations: [],
    panels: [],
    phone_1: "",
    phone_2: "",
    last_login: "",
    first_name: "",
    last_name: "",
    email: "",
    mail_issue_creation: false,
    mail_issue_done: false,
    mail_alarm: false,
    is_admin: false,
    is_tech: false,
    is_viewer: false,
    is_report: false,
    is_active: false,
    is_fireman: false,
    dri_user: false,
    token: "",
    language: "es",
};
export const ProfilesDateModel = {
    date_joined: "",
    updated_at: "",
    last_change_pass: "",
    blocked_at: "",
    confirmed_at: "",
    reset_password_to_at: "",
    last_login: "",
};
